import { useAuth } from 'hooks';
import { FC, memo, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { PageSpinner } from '../components';

type Props = {
  children: ReactNode;
}

/**
 * PrivateRoute
 *
 * - It shows a load component while the authentication is validated.
 * - If the user is authenticated, render the protected component.
 * - If it is not authenticated after validation, redirect to login.
 */
export const PrivateRoute: FC<Props> = memo(({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <PageSpinner />;
  }

  if (isAuthenticated) {
    return children
  }

  return <Navigate to="/login" replace />;
});
